import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row page-max-width q-mx-auto" }

import { computed } from 'vue';
import { useQuasar } from 'quasar';

// Personal components
import QPageTitle from 'src/view/components/QPageTitle.vue';

// Personal libs
import { RouteEnum } from 'src/shared/enum/route.enum';
import { IUser } from '@shared/interface/model.interface';
import { RoleEnum } from '@shared/enum/role.enum';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Globals
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'SiteMapPage',
  setup(__props) {

// Vendor
const $q = useQuasar();

/**
 * Computed properties
 */
const linkClass = computed<string>(() =>
  $q.dark.isActive ? 'router-link-white' : 'router-link-black',
);
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);
const isAdmin = computed<boolean>(
  () => connectedUser.value?.roles?.includes(RoleEnum.ROLE_ADMIN) === true,
);
const isSuperAdmin = computed<boolean>(
  () =>
    connectedUser.value?.roles?.includes(RoleEnum.ROLE_SUPER_ADMIN) === true,
);

return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: `Plan du site` }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_list, {
        padding: "",
        role: "list"
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" Page d'accueil "),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                top: "",
                avatar: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    color: "primary",
                    "text-color": "white",
                    icon: "home"
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("Accueil")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, { caption: "" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" Page d'accueil de l'application où vous pouvez retrouver le QR-Code permettant de partager le lien avec une autre personne. ")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        class: _normalizeClass(linkClass.value),
                        to: `/${_unref(RouteEnum).HOME}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "arrow_forward" }),
                          _cache[2] || (_cache[2] = _createTextVNode("Aller à la page d'accueil"))
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["class", "to"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Programmes "),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                top: "",
                avatar: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    color: "primary",
                    "text-color": "white",
                    icon: "checklist"
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Programmes")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, { caption: "" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Tableau présentant les programmes par ceinture et proposant aux personnes ayant un compte de visualiser l'exécution des techniques par des pratiquants confirmés. ")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        class: _normalizeClass(linkClass.value),
                        to: `/${_unref(RouteEnum).PROGRAMS}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "arrow_forward" }),
                          _cache[5] || (_cache[5] = _createTextVNode("Aller à la page des programmes"))
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["class", "to"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Contact "),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                top: "",
                avatar: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    color: "primary",
                    "text-color": "white",
                    icon: "email"
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Contact")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, { caption: "" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Formulaire de contact vous permettant de contacter les administrateurs de l'application. ")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        class: _normalizeClass(linkClass.value),
                        to: `/${_unref(RouteEnum).CONTACT}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "arrow_forward" }),
                          _cache[8] || (_cache[8] = _createTextVNode("Aller au formulaire de contact"))
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["class", "to"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Notes de version "),
          (connectedUser.value != null)
            ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    top: "",
                    avatar: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        color: "primary",
                        "text-color": "white",
                        icon: "list_alt"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("Notes de version")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode(" Formulaire de contact vous permettant de contacter les administrateurs de l'application. ")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(linkClass.value),
                            to: `/${_unref(RouteEnum).CHANGELOG}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "arrow_forward" }),
                              _cache[11] || (_cache[11] = _createTextVNode("Aller à la page des notes de version"))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "to"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Admin : utilisateurs "),
          (isAdmin.value || isSuperAdmin.value)
            ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    top: "",
                    avatar: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        color: "primary",
                        "text-color": "white",
                        icon: "group"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Gestion des utilisateurs")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" Permet, en fonction des droits accordés, de gérer les utilisateurs (ajout, modification, suppression, ...). ")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(linkClass.value),
                            to: `/${_unref(RouteEnum).USERS}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "arrow_forward" }),
                              _cache[14] || (_cache[14] = _createTextVNode("Aller à la page de gestion des utilisateurs"))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "to"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Admin : vidéos "),
          (isAdmin.value || isSuperAdmin.value)
            ? (_openBlock(), _createBlock(_component_q_item, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    top: "",
                    avatar: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        color: "primary",
                        "text-color": "white",
                        icon: "group"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Gestion des vidéos")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode(" Permet, en fonction des droits accordés, de gérer les vidéos (ajout, modification, suppression, validation, invalidation, visualisation, ...). ")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(linkClass.value),
                            to: `/${_unref(RouteEnum).VIDEOS}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "arrow_forward" }),
                              _cache[17] || (_cache[17] = _createTextVNode("Aller à la page de gestion des vidéos"))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "to"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})